(function () {
  'use strict';
  function measureHeader() {
    var header = document.querySelector('.section-header');
    if (header) document.body.style.setProperty('--sc-header-offset', Math.ceil(header.getBoundingClientRect().height) + 'px');
  }
  function init() {
    measureHeader();
    var header = document.querySelector('.section-header');
    if (header && window.ResizeObserver) new ResizeObserver(measureHeader).observe(header);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', measureHeader, { passive: true });
  document.addEventListener('shopify:section:load', measureHeader);
})();

/* ---- performance: pause looping animations that are off-screen or in a hidden tab ---- */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var SKIP = '[data-sc-pop], .sc-notify, cart-drawer, .sc-sticky';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('sc-off', !e.isIntersecting); });
  }, { rootMargin: '250px 0px' });
  function watch(scope) {
    (scope || document).querySelectorAll('.shopify-section').forEach(function (sec) {
      if (sec.scWatched || sec.querySelector(SKIP)) return;
      sec.scWatched = true; io.observe(sec);
    });
  }
  function start() { watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { watch(e.target.parentNode || document); });
  document.addEventListener('visibilitychange', function () { document.documentElement.classList.toggle('sc-tab-hidden', document.hidden); });
})();

/* ---- footer signup: send in the background, no page reload ---- */
(function () {
  'use strict';
  function bind(form) {
    if (!form || form.scAjax) return;
    form.scAjax = true;
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.DOMParser) return;            // old browser: normal submit
      var email = form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) return;                // let the browser show its message
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); form.classList.add('is-sending'); }
      var native = function () { form.scAjax = false; HTMLFormElement.prototype.submit.call(form); };
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (/\/challenge/.test(r.url) || !r.ok) { native(); return null; }  // Shopify wants the human check: do it the normal way
          return r.text();
        })
        .then(function (html) {
          if (html == null) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(form.id);
          if (!fresh) { native(); return; }
          form.innerHTML = fresh.innerHTML;
          form.classList.remove('is-sending');
          var ok = form.querySelector('.sc-news__ok'); if (ok) ok.focus();
        })
        .catch(native);
    });
  }
  function start() { bind(document.getElementById('sc-news-form')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
